import { Box, styled } from '@mui/material'

export const FairtradeAccountCard = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  backgroundColor: '#f8f6f4',
  borderRadius: theme.spacing(3),
  padding: '20px',
  boxShadow: '0px 18px 45px rgba(23, 34, 49, 0.08)',
  border: '1px solid rgba(23, 34, 49, 0.05)',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
}))

